// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "Pages_games_web_bacanagol_components_DynamicPhaseRenderer_index_js") return "dfda9dc26fdc0ec9703b.js";
	// return url for filenames based on template
	return undefined;
};